export default async function IsPhoneValid( phone ) {
    var re = /^[\d\+][\d\(\)\ -]{4,14}\d$/;
    var myPhone = phone;
    var valid = await re.test(myPhone);
    return valid;
};
